import React from 'react'
import { withRouter } from 'react-router-dom'
import Icon from '@softwaredev_cegeka/stix-core/dist/components/Icon'
import { Input } from '@softwaredev_cegeka/stix-form/dist/components'
import List from '@softwaredev_cegeka/stix-core/dist/components/List'
import {
    Button,
    Menu,
    Skeleton,
} from '@softwaredev_cegeka/stix-core/dist/components'
import Popover from '@softwaredev_cegeka/stix-core/dist/components/Popover'
import AsyncSelect from 'src/components/Forms/AsyncSelect'
import { Link } from 'react-router-dom'

import './searchableList.scss'

class BaseSearchableList extends React.Component {
    state = {
        searchString: '',
        showAddBtn: true,
        enableSubmitBtn: false,
    }

    searchItem = e => {
        this.setState({
            searchString: e.target.value,
        })
    }

    filteredItems() {
        const { searchString } = this.state
        const { type, data } = this.props
        const { dataField, itemDisplay } = type
        if (searchString) {
            return data[dataField].filter(item =>
                itemDisplay(item)
                    .toLowerCase()
                    .includes(searchString.toLowerCase())
            )
        }
        return data[dataField]
    }

    toggleAddBtn = () => {
        if (this.state.showAddBtn) {
            this.setState({ showAddBtn: false })
        } else {
            this.setState({ showAddBtn: true })
        }
    }

    addEntity = _ => {
        if (this.props.addEntityMethod) {
            this.props.addEntityMethod(this.state.relatedEntity.id)
            this.setState({
                showAddBtn: true,
            })
        } else {
            console.warn('Method not implemented! Current state:', this.state)
        }
    }

    handleItemsRender = response =>
        (this.props.filteredEntitiesFilter
            ? response.data.results.filter(this.props.filteredEntitiesFilter)
            : response.data.results
        ).map(item => ({
            id: item.id,
            label: this.props.type.selectDisplay(item),
            value: item.id,
        }))

    renderAddButton(entityName, displayEntityName) {
        let displayText = displayEntityName ? displayEntityName : entityName
        if (this.props.addEntityUrl) {
            return (
                <Link
                    to={{
                        pathname: this.props.addEntityUrl,
                        customProp: this.props.customProp,
                    }}
                >
                    <Button variant="naked" className={'drawer-add-btn'}>
                        <Icon icon="add" />
                        <span>Add {[displayText]}</span>
                    </Button>
                </Link>
            )
        }
        if (this.state.showAddBtn)
            return (
                <Button
                    variant="naked"
                    className={'drawer-add-btn'}
                    onClick={this.toggleAddBtn}
                >
                    <Icon icon="add" />
                    <span>Add {[displayText]}</span>
                </Button>
            )
        const { param = 'name_like' } = this.props.type
        return (
            <>
                <AsyncSelect
                    label="add"
                    srOnly
                    placeholder={`Add ${displayText}`}
                    apiConfig={{
                        url: this.props.filteredEntitiesUrl
                            ? this.props.filteredEntitiesUrl
                            : `/api/auth/${entityName}s`,
                        params: inputValue => ({
                            page: 1,
                            per_page: 100,
                            load_relationships: true,
                            [param]: inputValue,
                            ...this.props.sortParam,
                        }),
                    }}
                    itemRenderer={this.handleItemsRender}
                    defaultOptions={true}
                    onChange={obj => {
                        if (obj)
                            this.setState({
                                relatedEntity: obj,
                                enableSubmitBtn: true,
                            })
                        else
                            this.setState({
                                enableSubmitBtn: false,
                            })
                    }}
                />
                {this.state.enableSubmitBtn ? (
                    <Button
                        variant={'secondary'}
                        className={'submitBtn'}
                        onClick={this.addEntity}
                    >
                        Add
                    </Button>
                ) : null}
            </>
        )
    }

    renderConfirmationModal(entityName, data, item) {
        if (!this.props.removeEntityMethod) {
            console.warn('Method not implemented!')
            return
        }

        let message = ''
        let entityIid = null
        if (entityName === 'group') {
            message = this.props.confirmationMessage + ` ${item.name}?`
            entityIid = item.id
        }
        if (entityName === 'child tenant') {
            message =
                `Are you sure you want to unlink the child tenant ${item.name} ` +
                this.props.confirmationMessage +
                '?'
            entityIid = item.id
        }
        if (entityName === 'user') {
            message =
                this.props.confirmationMessage +
                ` ${item.first_name} ${item.last_name}?`
            entityIid = item.id
        }
        if (entityName === 'tenant') {
            message = this.props.confirmationMessage + ` ${item.tenant_name}?`
            entityIid = item.tenant_id
        }
        if (entityName === 'tenant admin') {
            message =
                this.props.confirmationMessage +
                ` ${item.first_name} ${item.last_name}?`
            entityIid = item.id
        }
        return (
            <div className="modal-wrapper">
                <div>{message}</div>
                <div className="button-modal-wrapper">
                    <Button
                        variant={'outline-danger'}
                        onClick={() => this.props.removeEntityMethod(entityIid)}
                    >
                        Confirm
                    </Button>
                </div>
            </div>
        )
    }

    hasAdGroups(item) {
        return item.ad_groups && item.ad_groups.length
    }

    render() {
        const {
            type,
            data,
            emptyListMessage,
            loading,
            optionButton,
            listItemUrl,
        } = this.props
        const {
            entityName,
            dataField,
            itemId,
            itemDisplay,
            detailItemDisplay,
            displayEntityName,
        } = type
        let filteredItems = this.filteredItems()
        let ad_linked_group =
            entityName === 'mapped_ad_groups' || // we only want to add AD groups from the edit form
            (!!(data.mapped_ad_groups && data.mapped_ad_groups.length) &&
                entityName !== 'app_permissions') // we want to allow adding app permissions on all groups

        const canEdit = !(
            process.env.REACT_APP_ENABLE_EDIT_TENANT_FUNCTIONALITY !== 'true' &&
            entityName === 'tenant'
        )

        if (loading) {
            return <Skeleton count={5} />
        } else if (!data[dataField]?.length) {
            return (
                <>
                    <span className={'emptyTabMessage'}>
                        {emptyListMessage}
                    </span>
                    {!ad_linked_group &&
                        canEdit &&
                        this.renderAddButton(entityName, displayEntityName)}
                </>
            )
        }

        return (
            <>
                <div className="content-search-field">
                    <Icon icon="search" />
                    <Input
                        placeholder={'Search'}
                        srOnly
                        onChange={this.searchItem}
                    />
                </div>
                {filteredItems && filteredItems.length > 0 ? (
                    <List
                        variant="multiColumn"
                        className="custom-list-row"
                        role={'list'}
                    >
                        {filteredItems.map(item => (
                            <List.Item
                                key={item[itemId]}
                                style={{ border: null }}
                                role={'listitem'}
                            >
                                <div>
                                    {listItemUrl ? (
                                        <Link
                                            to={{
                                                pathname: listItemUrl.pathname,
                                                search: listItemUrl.search(
                                                    item
                                                ),
                                            }}
                                        >
                                            {itemDisplay(item)}
                                        </Link>
                                    ) : (
                                        <span>{itemDisplay(item)}</span>
                                    )}
                                    {detailItemDisplay ? (
                                        <div className={'detail-item'}>
                                            {detailItemDisplay(item)}
                                        </div>
                                    ) : null}
                                </div>
                                {canEdit &&
                                    (!ad_linked_group ||
                                        entityName !== 'user') &&
                                    !this.props.disableRemoveButton && (
                                        <Popover
                                            rootClose={true}
                                            placement="left"
                                            trigger="click"
                                            content={this.renderConfirmationModal(
                                                entityName,
                                                data,
                                                item
                                            )}
                                        >
                                            {!ad_linked_group &&
                                            !optionButton ? (
                                                <Button variant="naked">
                                                    <Icon icon={'delete'} />
                                                </Button>
                                            ) : (
                                                <Menu.Option
                                                    contextMenu={[
                                                        {
                                                            name: 'Edit',
                                                            icon: 'edit',
                                                            onClick: () => {
                                                                this.props.history.push(
                                                                    ad_linked_group
                                                                        ? `/group-form/${data.id}`
                                                                        : `/group-form/${data.id}/app-permissions-form/${item.id}`
                                                                )
                                                            },
                                                        },
                                                    ]}
                                                    icon={'actions-vert'}
                                                />
                                            )}
                                        </Popover>
                                    )}
                            </List.Item>
                        ))}
                    </List>
                ) : (
                    <span className={'emptyTabMessage'}>
                        No entry matches your search.
                    </span>
                )}
                {!ad_linked_group &&
                    canEdit &&
                    this.renderAddButton(entityName, displayEntityName)}
            </>
        )
    }
}

export default withRouter(BaseSearchableList)
